import { render } from "./login-page.vue?vue&type=template&id=4ae427c5"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/auth/login-page.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ae427c5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ae427c5', __exports__)) {
    console.log('reload')
    api.reload('4ae427c5', __exports__)
  }
  
  module.hot.accept("./login-page.vue?vue&type=template&id=4ae427c5", () => {
    console.log('re-render')
    api.rerender('4ae427c5', render)
  })

}


export default __exports__